export const drawerItemsMain = [
  {
    key: "ProductTracker",
    title: "Customer Order Tracker",
    routes: [
      {
        nav: "ProductTrackerReport",
        routeName: "ProductTrackerReport",
        title: "Product Tracker Report",
      },
    ],
  },
  {
    key: "TrackerDashboard",
    title: "Customer Order Dashboard",
    routes: [
      {
        nav: "TrackerDashboardReport",
        routeName: "TrackerDashboardReport",
        title: "Tracker Dashboard Report",
      },
    ],
  },
  {
    key: "ChinaTracker",
    title: "China Tracker",
    routes: [
      {
        nav: "ChinaTrackerReport",
        routeName: "ChinaTrackerReport",
        title: "China Tracker Report",
      },
    ],
  },
  {
    key: "ChinaShipment",
    title: "China Shipment",
    routes: [
      {
        nav: "ChinaShipmentReport",
        routeName: "ChinaShipmentReport",
        title: "China Shipment Report",
      },
    ],
  },
  {
    key: "GlobalShipment",
    title: "Global Shipment",
    routes: [
      {
        nav: "GlobalShipmentReport",
        routeName: "GlobalShipmentReport",
        title: "Global Shipment Report",
      },
    ],
  },
];
